// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type HasUsersWithoutEntry } from "../../api";
import { useHasUsersWithoutEntry as useGetter } from "../hooks";
import { useQuery, type UseQueryOptions } from "react-query";

export function useHasUsersWithoutEntry(
  id: string,
  options: Omit<
    UseQueryOptions<HasUsersWithoutEntry, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): HasUsersWithoutEntry {
  const getter = useGetter();
  return useQuery(
    ["free-days", id, "has-users-without-entry"],
    () => getter(id),
    options
  ).data!;
}
